import React from "react";

const Roster = ({ players }) => {
  const toLi = (player) => <li key={player.name}>{player.name}</li>;

  return <ul>{players.map(toLi)}</ul>;
};

export default Roster;
